export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
              tagname: 'div',
              name: "Colunas Diferenciais",
              attributes: { class: 'row-cubo d-col-reverse' },
              components: [
                {
                  type: 'columnImgDifferences4',
                },
                {
                  type: 'columnDifferences4',
                },
      
              ],
              styles: `
             .row-cubo{
                display: flex; 
                width:100%; 
             }
             @media (max-width:992px){
              .d-col-reverse{
                flex-direction:column-reverse;
              }
             }
            `,
            },
          },
          view: {
      
          },
};
  return component; 
};